import React, { FC } from 'react'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { Box, Link, Text } from '@moonpig/launchpad-components'
import { useStoreId } from '@moonpig/web-core-stores'
import { useProductStore } from '../../../contexts/product'
import { E_CARD_SIZE_ID } from '../../../constants'
import { useProductsLocaleText } from '../../../locale'
import { ModuleContext, ModuleSimplifiedDeliveryInfoText } from '../../types'

type Props = {
  module: ModuleSimplifiedDeliveryInfoText
  context: ModuleContext
}

const StyledFooterLink = styled(Link)`
  ${s({ color: 'colorTextLabel' })}
  text-decoration: underline;
`

export const SimplifiedDeliveryInfoTextModule: FC<Props> = ({ module }) => {
  const [{ product }] = useProductStore()
  const localiseText = useProductsLocaleText()
  const region = useStoreId()
  const isDripPricingEnabled =
    useExperiment('drip-pricing', {
      fallback: 'control',
    }) === 'variant'

  const availableVariants = product.variants.filter(
    v => !module.unavailableVariants?.includes(v.key),
  )
  const isECardExclusive = availableVariants.every(
    v => v.key === E_CARD_SIZE_ID,
  )
  const deliveryOptionsInfoEnabled = isDripPricingEnabled && !isECardExclusive

  if (!deliveryOptionsInfoEnabled) {
    return null
  }

  return (
    <Box mb={8}>
      <Text typography="typeBodyCaption" color="colorTextLabel">
        {localiseText('variant_selector.footer_line_one')}{' '}
        {localiseText('variant_selector.footer_line_two_part_one')}
        <StyledFooterLink
          href={`/${region}/delivery-information`}
          target="_blank"
        >
          {localiseText('variant_selector.footer_line_two_part_two')}
        </StyledFooterLink>
        {localiseText('variant_selector.footer_line_two_part_three')}
      </Text>
    </Box>
  )
}
